module.exports = __webpack_public_path__ + "res/dummy_question.0e9cb8c03f9758e63bf08b2b3415edbc.png";